module.exports = __webpack_public_path__ + "img/icon-credit-card.f7717101.svg";